import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { getIPAddress } from "../../models/notifications";

export default function MainFlyerComponent() {
    const { page } = useParams();
    const [searchParams] = useSearchParams();
    const source = searchParams.get("source") ?? "unknown";

    useEffect(() => {
        getIPAddress((ipAddress) => {
            fetch("https://server.pabloo.com/virtual_bank/send_slack_message", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    message: `📰 Flyer scan: /${page}\nSource: ${source}\nIP address: ${ipAddress}`,
                    channel: "#extern-academy",
                }),
                keepalive: true,
            });
            window.location.href = `/pages/flyers/${page}.html`;
        });
    }, [page, source]);

    return null;
}
